import {Component, Input, OnInit} from '@angular/core';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'achoo-icon-tooltip',
  templateUrl: './achoo-icon-tooltip.component.html',
  styleUrls: ['./achoo-icon-tooltip.component.scss']
})
export class AchooIconTooltipComponent implements OnInit {
  @Input() width = 9;
  @Input() height = 9;
  @Input() tooltipMsg: string;
  @Input() placement = 'bottom';

  constructor(private pdfService: PdfExportService) { }

  ngOnInit() {
  }

  get widthInPx() {
    return `${this.width}px`;
  }

  get heightInPx() {
    return `${this.height}px`;
  }

  get shouldShowTooltip() {
    return !this.pdfService.exportingPdf;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-icon-tooltip/achoo-icon-tooltip.component.ts